var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31469 15V9.86H0.754688V8.58H2.31469V6.94H0.754688V5.66H2.31469V0.719999H4.39469L6.29469 5.66H8.65469V0.719999H10.2347V5.66H11.7947V6.94H10.2347V8.58H11.7947V9.86H10.2347V15H8.13469L6.23469 9.86H3.87469V15H2.31469ZM3.87469 8.58H5.75469L5.15469 6.94H3.83469L3.87469 8.58ZM8.65469 12.18H8.73469L8.67469 9.86H7.83469L8.65469 12.18ZM3.83469 5.66H4.67469L3.83469 3.18H3.75469L3.83469 5.66ZM7.35469 8.58H8.69469L8.65469 6.94H6.75469L7.35469 8.58Z",
    fill: "#CB3050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaCurrency);
export default __webpack_public_path__ + "static/media/naira_currency.787fca85a60cf8ee0f324518bbd2ef63.svg";
export { ForwardRef as ReactComponent };